module.exports = __webpack_public_path__ + "static/keywords-da2c443a3150ce774ccc0b5ddf1771ed.png";